import ActionSheetItem from '@omni/kit/components/KitActionSheetItem';
import { useTranslation } from '@omni/kit/hooks/useTranslation';
import Colors from '@omni/kit/theming/Colors';
import React, { ReactElement } from 'react';
import { Platform, StyleSheet } from 'react-native';

export default function MoreActionSheet({
  isManager,
  canLeave,
  isMuted,
  onLeaveGroup,
  onDeleteGroup,
  onMuteGroup,
}: {
  isManager: boolean;
  canLeave: boolean;
  isMuted: boolean;
  onLeaveGroup: () => void;
  onDeleteGroup: () => void;
  onMuteGroup: () => void;
}): ReactElement | null {
  const { t } = useTranslation(['groups']);

  return (
    <>
      {Platform.OS !== 'web' ? (
        <ActionSheetItem
          icon={isMuted ? 'notifications' : 'notifications-off'}
          iconColor={Colors.N900}
          label={isMuted ? t('unmuteNotifications') : t('muteNotifications')}
          onPress={onMuteGroup}
        />
      ) : null}
      {canLeave ? (
        <ActionSheetItem
          icon='logout'
          iconColor={Colors.N900}
          label={t('labelLeaveGroup')}
          onPress={onLeaveGroup}
        />
      ) : null}
      {isManager ? (
        <ActionSheetItem
          icon='delete'
          iconColor={Colors.R500}
          label={t('labelDeleteGroup')}
          onPress={onDeleteGroup}
        />
      ) : null}
    </>
  );
}
//******************************************************************************
// Styles
//******************************************************************************
const styles = StyleSheet.create({});
